import { render } from "./LCE26_Performance.vue?vue&type=template&id=3c48462c"
import script from "./LCE26_Performance.vue?vue&type=script&lang=js"
export * from "./LCE26_Performance.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__